// extracted by mini-css-extract-plugin
module.exports = {"navigation":"styles_navigation__3ep3X","logo":"styles_logo__3dRyJ","navbar":"styles_navbar__2z0Rj","link":"styles_link__3Lj8X","active":"styles_active__2CGQL"};